export default __webpack_public_path__ + "static/media/receipt.2c78ed64.jpg";